<template>
  <div>
    <a-row :gutter="16">
      <a-col span="8">
        <h3>Geselecteerde velden</h3>
        <div v-show="selectedValues.length === 0">
          Selecteer eerst een entiteit en daarna velden die je hier wilt toevoegen.
        </div>
        <div v-show="selectedValues.length > 0">
          <p>Sleep de velden om ze te herordenen</p>
          <draggable v-model="selectedValues" group="templating-values" @start="drag=true" @end="drag=false">
            <div v-for="(value, index) in selectedValues" :key="index" class="item">
              <a-row>
                <a-col span="20">
                  <a-icon type="drag" style="margin-right: 1rem;"/>
                  <span class="key">
                                        {{'{' + value.key + '}'}}
                                    </span>
                </a-col>
                <a-col span="4" style="text-align: right">
                  <a-tooltip placement="top">
                    <template slot="title">
                      <span>Verwijderen</span>
                    </template>
                    <a-button @click="removeAttribute(index)" :key="value.id" shape="circle"
                              type="danger"
                              icon="close" size="small"></a-button>
                  </a-tooltip>
                </a-col>
              </a-row>
            </div>
          </draggable>
          <a-button @click="submit" type="primary">Selectie opslaan</a-button>
        </div>
      </a-col>
      <a-col span="8">
        <h3>Objecten</h3>
        <div v-show="baseDefinition == null">
          Laden...
        </div>
        <div v-if="baseDefinition !== null">
          <DefinitionComponent :definition="baseDefinition"
                               @selectDefinition="onSelectedDefinition"></DefinitionComponent>
        </div>
      </a-col>
      <a-col span="8">
        <div v-show="definitionValues.length > 0 && selectedDefinition !== null">
          <h3>{{ selectedDefinitionName }} velden</h3>
          <a-input-search
              placeholder="Zoeken"
              @search="onSearch"
              @input="onSearch"
              enterButton
          ></a-input-search>
        </div>
        <ValueComponent
            v-for="value in availableDefinitionValues"
            :key="value.key"
            :definition="selectedDefinition"
            :value="value"
            @selectAttribute="onSelectedAttribute">
        </ValueComponent>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import templatingApi from '~/api/templating';
import store from '../store';
import draggable from 'vuedraggable'
import DefinitionComponent from "~/modules/templating/components/DefinitionComponent";
import ValueComponent from "~/modules/templating/components/ValueComponent";

export default {
  name: "SelectionComponent",
  props: {
    sourceClass: {
      type: [String, Number],
      required: true
    },
  },
  data() {
    return {
      templateDefinitions: [],
      baseDefinition: null,
      selectedDefinition: null,
      initialized: false,
      searchQuery: ''
    }
  },
  computed: {
    ...mapGetters({
      selectedValues: '$_templating/getSelection',
      // selectedDefinition: '$_templating/selectedDefinition',
    }),
    selectedValues: {
      get() {
        return store.state.selection
      },
      set(value) {
        // this.$store.commit('selection', value)
        this.$store.dispatch('$_templating/getSelection', value)
      }
    },
    selectedDefinitionName() {
      return this.selectedDefinition ? this.selectedDefinition.name : '';
    },
    definitionValues() {
      let values = [];
      if (store.state.selectedDefinition !== null) {
        values = values.concat(store.state.selectedDefinition.attributes.data);
        values = values.concat(store.state.selectedDefinition.computed_attributes.data);
      }
      return values;
    },
    availableDefinitionValues() {
      if (this.searchQuery.length > 0) {
        let query = this.searchQuery
        return this.definitionValues.filter(function (value) {
          return value.name.search(query) !== -1 || value.key.search(query) !== -1
        })
      }
      return this.definitionValues
    }
  },
  created() {
    const STORE_KEY = '$_templating';
    // eslint-disable-next-line no-underscore-dangle
    if (!(STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(STORE_KEY, store);
    }
  },
  mounted() {
    // this.getTemplateDefinitionByClass(this.sourceClass);
    this.initializeDefinitions();
  },
  components: {
    draggable,
    DefinitionComponent,
    ValueComponent
  },
  methods: {
    removeAttribute(index) {
      let selection = this.selectedValues;
      this.selectedValues = selection.filter(function (value, i) {
        return i !== index;
      });
    },
    isActive(name) {
      if (this.selectedDefinition) {
        return this.selectedDefinition.name === name;
      }
      return false;
    },
    onSelectedDefinition(definition) {
      this.selectedDefinition = definition;
      this.$store.dispatch('$_templating/getSelectedDefinition', definition);
    },
    onSelectedAttributes(attributes) {
      let selection = store.state.selection;
      attributes.forEach(function (attribute) {
        selection.push(attribute);
      });

      this.$store.dispatch('$_templating/getSelection', selection);
    },
    onSelectedAttribute(attribute) {
      let selection = store.state.selection;
      selection.push(attribute);
      this.$store.dispatch('$_templating/getSelection', selection);
    },
    onSearch(e) {
      this.searchQuery = e.target.value
    },
    selectDefinition(definition) {
      this.$store.dispatch('$_templating/getSelectedDefinition', definition);
    },
    getTemplateDefinitionByClass(className) {
      templatingApi.getDefaultAttributesByClass(className).then((response) => {
        this.templateDefinition = response.data;
      });
    },
    initializeDefinitions() {
      // initialize base definition
      templatingApi.getDefinitionByClass(this.sourceClass).then((response) => {
        this.baseDefinition = response.data;
        this.selectedDefinition = this.baseDefinition;

        // initialize base definition
        templatingApi.getDefaultAttributesByClass(this.sourceClass).then((response) => {
          let defaultSelection = [];

          response.data.forEach(function (attribute) {
            defaultSelection.push({
              key: attribute.key_with_prefix,
              name: attribute.name,
            })
          });

          this.onSelectedAttributes(defaultSelection);
        });
      });
    },
    submit() {
      this.$emit('submit', this.selectedValues);
    }
  }
}
</script>

<style scoped>
.item {
  border: solid 1px #ccc;
  border-radius: 3px;
  margin: .5rem;
  padding: 1rem 1.5rem;
  clear: both;
  background: white;
}

.item .key {
  background: #839aaf;
  border-radius: 2px;
  padding: .5rem;
  color: white;
  font-family: monospace;
  font-weight: 500;
  display: inline-block;
  font-size: 12px;
}

.item .remove-button {
  float: right;
  clear: both;
}

.definition-list {
  background-color: white;
}

.definition-item {
  cursor: pointer;
}

.definition-item:hover {
  background-color: #ccc;
}

.definition-item.active {
  background-color: #0e70aa;
  color: white;
}
</style>